module.exports = __webpack_public_path__ + "static/pc.vp9-16076e5e49815f0e77288b02e58d9c16.webm";